export interface MediumCacheModel {
  id: string | null;
  url: string | null;
}
